import * as theme from '@zero/design-tokens/build/js/variables';
import styled from 'styled-components';

export const Title = styled.h1`
    font-family: ${theme.ZrFontFamilyDigitalLight};
    font-size: ${theme.ZrFontSizeSm};
    font-weight: ${theme.ZrFontWeightRegular};
    margin-bottom: ${theme.ZrSpacingVerticalLg};
    color:${theme.ZrColorNeutralMedium02};
`;